import { z } from 'zod';
export const BUSINESS_TIME_ZONE = 'America/Bogota';
/** Fecha de negocio `YYYY-MM-DD` (zona America/Bogota). */
export const BusinessDateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Fecha de negocio YYYY-MM-DD')
    .meta({ id: 'BusinessDate', description: 'Fecha de negocio YYYY-MM-DD en America/Bogota.' });
/** Instante ISO 8601 en UTC (`timestamptz`). */
export const TimestampSchema = z.iso
    .datetime({ offset: true })
    .meta({ id: 'Timestamp', description: 'Instante ISO 8601 (UTC).' });
const businessDateFormatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: BUSINESS_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
});
/** Convierte un instante a fecha de negocio en America/Bogota. */
export function toBusinessDate(instant) {
    return businessDateFormatter.format(instant);
}
/** Fecha de negocio actual según el reloj. */
export function businessToday(clock) {
    return toBusinessDate(clock.now());
}
/** Suma días a una fecha de negocio (aritmética de calendario, sin zona). */
export function addDays(date, days) {
    const [y, m, d] = date.split('-').map(Number);
    const utc = new Date(Date.UTC(y, m - 1, d + days));
    return utc.toISOString().slice(0, 10);
}
/** Suma milisegundos a un instante del reloj sin usar `Date.now()`. */
export function addMs(instant, ms) {
    return new Date(instant.getTime() + ms);
}
//# sourceMappingURL=clock.js.map